import React from 'react';
import { Box, Typography } from '@mui/material';

const ImpactionTextPreview = ({ text }) => {
    if (!text) return null;

    return (
        <Box sx={{ mt: 2, p: 1.5, bgcolor: '#e3f2fd', borderLeft: '4px solid #2196f3', borderRadius: '0 4px 4px 0' }}>
            <Typography variant="caption" sx={{ display: 'block', color: 'text.secondary', fontWeight: 'bold', mb: 0.5 }}>
                Report Text Preview:
            </Typography>
            <Typography variant="body2" sx={{ fontStyle: 'italic', color: '#1565c0' }}>
                {text}
            </Typography>
        </Box>
    );
};

export default ImpactionTextPreview;
